var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-page-container"},[_c('carousel'),_c('index-floor'),_c('advert-mask')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }